import { RootReducer } from '../rootReducer';

export const createProcessingSelector = (actions: string[]) => (state: RootReducer) => {
  // add another condition if I break something: action.indexOf('GET_') < 0 &&
  return actions.some((action) => state.loading[action]);
};
